import type { EventPayloads, PublicBetGameAction } from '../helpers/types';
import { EventEmitter } from './EventEmitter';
import { store } from '../store/store';

const MINOR_UNITS_PER_MAJOR = 100;

const { getState } = store;

export class StoreSyncController {
    constructor() {
        EventEmitter.on('common:connection', this.onConnection);
        EventEmitter.on('common:balance', this.onBalance);
        EventEmitter.on('common:social-layer', this.onSocials);
        EventEmitter.on('common:public-win', this.onPublicWin);
        EventEmitter.on('common:public-bet', this.onPublicBet);
        EventEmitter.on('horses:show', this.onShow);
        EventEmitter.on('horses:bet', this.onBet);
    }

    private onConnection(payload: EventPayloads['common:connection']) {
        getState().setUser(payload.userRef, payload.goosicornUsername);
    }

    private onBalance(payload: EventPayloads['common:balance']) {
        getState().setBalanceAndCurrency(payload.amount / MINOR_UNITS_PER_MAJOR, payload.currency);
    }

    private onSocials(payload: EventPayloads['common:social-layer']) {
        getState().setSocials(payload.socialLayerJwt, payload.socialServiceUrl);
    }

    private onPublicWin(payload: EventPayloads['common:public-win']) {
        if (getState().username === payload.goosicornUsername) {
            getState().updateNetWin(payload.amount / MINOR_UNITS_PER_MAJOR);
        }
    }

    private onPublicBet(payload: EventPayloads['common:public-bet']) {
        const gameAction = JSON.parse(payload.gameAction) as PublicBetGameAction;
        getState().incrementRacerBet(gameAction.selection);
    }

    private onShow(payload: EventPayloads['horses:show']) {
        getState().setBet(payload.defaultBet / MINOR_UNITS_PER_MAJOR);
        getState().setBets(payload.betLevels.map((bet) => bet / MINOR_UNITS_PER_MAJOR));
    }

    private onBet(payload: EventPayloads['horses:bet']) {
        getState().updateNetWin(-payload.bet / MINOR_UNITS_PER_MAJOR);
        getState().setBetOnRacer(payload.selection);
    }
}
